import { fmtTL } from "../../lib/format";
import AmountInput from "../AmountInput";
import { Field, ReadonlyBox, inputCls } from "./fields";

function BuyPriceInput({ form, change }) {
  return (
    <Field label="Taşeron Birim Fiyatı (Alış) — manuel">
      <AmountInput testid="entry-buy-price" value={form.buy_price} onChange={(v) => change("buy_price", v)} placeholder="örn. 1.200,75" className={inputCls} />
    </Field>
  );
}

// Birim fiyat kutuları: başka taşeron (alış manuel) / kart fiyatları (salt okunur) / tamamen manuel; hideSub: şube/müşteri yetkilisi alış fiyatını görmez
function UnitPriceFields({ form, change, baskaOverride, hasCardPrices, assignment, hideSub }) {
  if (hideSub) {
    return hasCardPrices || baskaOverride
      ? <ReadonlyBox label="Birim Fiyat" value={fmtTL(assignment.sell_price)} testid="entry-sell-price-fixed" />
      : <Field label="Birim Fiyat — manuel"><AmountInput testid="entry-sell-price" value={form.sell_price} onChange={(v) => change("sell_price", v)} placeholder="örn. 1.500,50" className={inputCls} /></Field>;
  }
  if (baskaOverride) {
    return (
      <>
        <BuyPriceInput form={form} change={change} />
        <ReadonlyBox label="Müşteri Birim Fiyatı (Satış) — mevcut atanan" value={fmtTL(assignment.sell_price)} />
      </>
    );
  }
  if (hasCardPrices) {
    return (
      <>
        <ReadonlyBox label="Taşeron Birim Fiyatı (Alış)" value={fmtTL(assignment.buy_price)} />
        <ReadonlyBox label="Müşteri Birim Fiyatı (Satış)" value={fmtTL(assignment.sell_price)} />
      </>
    );
  }
  return (
    <>
      <BuyPriceInput form={form} change={change} />
      <Field label="Müşteri Birim Fiyatı (Satış) — manuel">
        <AmountInput testid="entry-sell-price" value={form.sell_price} onChange={(v) => change("sell_price", v)} placeholder="örn. 1.500,50" className={inputCls} />
      </Field>
    </>
  );
}

export default function PriceFields({ form, change, editMode, service, baskaOverride, hasCardPrices, assignment, hideSub }) {
  const qtyLocked = !editMode && !form.subcontractor_id && !hideSub;
  return (
    <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
      <Field label={`Miktar${service ? ` (${service.unit})` : " (Adet/m²/Kişi)"}`}>
        <AmountInput testid="entry-quantity" disabled={qtyLocked} title={qtyLocked ? "Önce taşeron seçin" : ""} value={form.quantity}
          onChange={(v) => change("quantity", v)} placeholder="örn. 1.500,50" className={`${inputCls} disabled:bg-slate-50 disabled:text-slate-400`} />
      </Field>
      <UnitPriceFields form={form} change={change} baskaOverride={baskaOverride} hasCardPrices={hasCardPrices} assignment={assignment} hideSub={hideSub} />
    </div>
  );
}
